
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/members/account/certification/recertification",
      function () {
        return require("private-next-pages/members/account/certification/recertification.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/members/account/certification/recertification"])
      });
    }
  